
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-transform-demo-xflow-components-transform"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.zh.md?type=demo')
};